import { Component, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { UserSimpleGamification } from '@app/leaderboard/model/user.model';
import { DataTestModule } from '@app/shared/directive/data-test';
import { PipeModule } from '@app/shared';
import { IconComponent } from '@app/tw-shared/components';

@Component({
    selector: 'app-leaderboard-item',
    imports: [CommonModule, DataTestModule, PipeModule, IconComponent, TranslateModule],
    templateUrl: './leaderboard-item.component.html',
    styleUrls: ['./leaderboard-item.component.scss'],
})
export class LeaderboardItemComponent {
    private readonly translateService = inject(TranslateService);
    @Input() user: any;

    /**
     * returns user's fullname (name + surname) or "me" if he/she is currently logged in
     * @param user user data
     */
    getUserFullName(user: UserSimpleGamification) {
        if (user.me) {
            return this.translateService.instant('v3-globale-me');
        }
        return `${user.firstname} ${user.surname}`;
    }

    getTrendColor(trend: string) {
        switch (trend) {
            case 'success':
                return 'primary';
            case 'muted':
                return 'black';
            case 'muted-2':
                return 'black-10';
            case 'danger':
                return 'danger';
        }
    }
}
